import { render, staticRenderFns } from "./ServiceComponent.vue?vue&type=template&id=1c8bc887&lang=pug&"
import script from "./ServiceComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComponent.vue?vue&type=style&index=0&id=1c8bc887&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports